import { useEffect, useState } from "react";

const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/Mobi|Android/i.test(ua)) {
    if (Math.min(window.innerWidth, window.innerHeight) >= 768) {
      return "tablet";
    }
    return "phone";
  }
  return "desktop";
};

const getOrientation = () => {
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
};

export default function useDeviceInfo() {
  const [deviceType, setDeviceType] = useState(getDeviceType());
  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType());
      setOrientation(getOrientation());
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return { deviceType, orientation };
}